import { createInertiaApp } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";

import Layout from "../Layout";

createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.glob("../pages/**/*.tsx", { eager: true });
    let page = pages[`../pages/${name}.tsx`];
    page.default.layout = page.default.layout || ((page) => <Layout>{page}</Layout>);
    return page;
  },
  setup({ el, App, props }) {
    Sentry.init({
      dsn: "https://56b811ca5b724e2b36e489248ef68d71@o4508813751222272.ingest.us.sentry.io/4508891396505600",
      integrations: [],

      enabled: import.meta.env.PROD,

      tracesSampleRate: 0.5,
    });

    const container = document.getElementById(el.id);
    const root = createRoot(container);
    root.render(<App {...props} />);
  },
});
